import { Avatar, Typography } from "@mui/material";
import styled from "styled-components";
import theme from "theme";

type Props = {
  name: string;
  caption: string;
  text: string;
  iconUrl: string;
};

const MessageCard = (props: Props) => {
  return (
    <Card>
      <CardCommentatorAbout>
        <CardTitle color="textPrimary">{props.name}</CardTitle>
        <CardCaption color="textSecondary">{props.caption}</CardCaption>
      </CardCommentatorAbout>
      <CardImage src={props.iconUrl} alt={`${props.name}のアイコン画像`} />
      <CardText color="textPrimary">{props.text}</CardText>
    </Card>
  );
};

const Card = styled.div`
  display: grid;
  grid-template-columns: auto 100px;
  grid-template-rows: 100px auto;
  gap: 16px 24px;
  height: auto;
  margin: 12px;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(42, 42, 42, 1);
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
  font-family: "Noto Sans JP", sans-serif;
  ${theme.breakpoints.down("sm")} {
    grid-template-columns: 70px 1fr;
    grid-template-rows: max-content max-content auto;
    gap: 8px 12px;
    margin: 8px;
    padding: 16px 12px;
  }
`;

const CardCommentatorAbout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 200px;
  ${theme.breakpoints.down("sm")} {
    max-width: 100%;
  }
`;
const CardTitle = styled(Typography)`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.6;
  ${theme.breakpoints.down("sm")} {
    font-size: 14px;
  }
`;
const CardCaption = styled(Typography)`
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  ${theme.breakpoints.down("sm")} {
    font-size: 11px;
  }
`;

const CardImage = styled(Avatar)`
  width: 100px;
  height: 100px;
  background-color: #fff;
  ${theme.breakpoints.down("sm")} {
    grid-column: 1/2;
    grid-row: 1/3;
    width: 70px;
    height: 70px;
  }
`;

const CardText = styled(Typography)`
  grid-column: 1/3;
  text-align: justify;
  font-feature-settings: "halt" on;
  font-size: 14px;
  line-height: 1.6;
  word-wrap: break-word;
  white-space: pre-wrap;

  ${theme.breakpoints.down("sm")} {
    grid-column: 2/3;
    margin-top: 0px;
    font-size: 12px;
  }
`;

export default MessageCard;
